import React from 'react';
import TransientThoughtFeedItem from './TransientThoughtFeedItem';

/**
 * Inline scrollable history of previous comments, rendered below the live area.
 * Shows newest first while deriving colour/position/key from the stable
 * chronological index so prepending a new comment never reshuffles the rest.
 */
const TransientThoughtHistoryFeed = ({
  prevComments, ttId, isBubbleStyle, colors, fontFamily, fontSize, showUsername
}) => {
  if (!prevComments.length) return null;

  return (
    <div className="w-full flex flex-col gap-3 px-4 py-6 md:px-8">
      {prevComments.map((_, chronoIdx) => {
        const displayIdx = prevComments.length - 1 - chronoIdx;
        const item = prevComments[displayIdx];
        return (
          <TransientThoughtFeedItem
            key={item.id || `${ttId}-prev-${displayIdx}`}
            words={item.body || item.words}
            username={item.username}
            index={displayIdx}
            isBubbleStyle={isBubbleStyle}
            colors={colors}
            fontFamily={fontFamily}
            fontSize={fontSize}
            transientThoughtShowUsername={showUsername}
            positionKey={displayIdx % 2 === 0 ? 'topLeft' : 'topRight'}
          />
        );
      })}
    </div>
  );
};

export default TransientThoughtHistoryFeed;
